import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { BLOG_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";

import BlogCommentForm from "../../components/BlogDetails/BlogCommentForm";
import BlogComments from "../../components/BlogDetails/BlogComments";
import BlogDetails from "../../components/BlogDetails/BlogDetails";
import LayoutBlog from "../../layouts/LayoutBlog";

import {useFetchProjectById} from "../../components/BlogList/fetchProjects"
const BlogDetailsPage = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { project } = useFetchProjectById(id);

  const pageSeo = useMemo(() => {
    const title = project?.title || project?.fields?.title || "Article";
    return {
      ...BLOG_SEO,
      title: `${title} | Treydora Blog`,
      description: project?.excerpt || BLOG_SEO.description,
      robots: "noindex, follow",
    };
  }, [project]);

  usePageSeo(pageSeo);

  return (
    <LayoutBlog pageTitle={"Blog Details"} item={"BLOG DETAILS"}>
      {project ? <BlogDetails data={project}/>: null} 
    {/*   <BlogComments /> */}
    {/*   <BlogCommentForm /> */}
    </LayoutBlog>
  );
};

export default BlogDetailsPage;
